export { TrustBox } from './src/TrustBox'
export type { TrustBoxProps } from './src/TrustBox'
